import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import FormInputWithLabel from '../../Components/Global_Components/form/FormInputWithLabel';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {fetchPatientDetailsUuid, postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import './planningSummary.scss';

export default function PlanningSummary(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: '',
    name: '',
    date: '',
    time: '',
    status: 'Not Visited',
    notes: '',
    patient_id: ''
  });

  const [patientOne_UUId, setPatientOne_UUId] = useState('');
  const [femaleProtocolType, setFemaleProtocolType] = useState('Normoresponders');
  const [maleProtocolType, setMaleProtocolType] = useState('Male Factor');

  const [showTables, setShowTables] = useState({
    investigation: true,
    plan: true,
    'female-medication': true,
    'male-medication': true,
    'female-pretreatment-protocol': true,
    'male-pretreatment-protocol': true
  });

  const investigationHeaders = [
    {key: 'investigation', label: 'Investigation'},
    {key: 'female', label: 'Female'},
    {key: 'male', label: 'Male'}
  ];

  const planHeaders = [
    {key: 'female', label: 'Female'},
    {key: 'male', label: 'Male'}
  ];

  const medicationHeaders = [
    {key: 'sno', label: 'S.No'},
    {key: 'drug', label: 'Drug'},
    {key: 'genericName', label: 'Generic Name'},
    {key: 'dose', label: 'Dose'},
    {key: 'frequency', label: 'Frequency'},
    {key: 'time', label: 'Time'},
    {key: 'duration', label: 'Duration'}
  ];

  const preTreatmentHeaders = [
    {key: 'sno', label: 'S.No'},
    {key: 'drug', label: 'Drug (Brand Name) / Generic Category'},
    {key: 'dose', label: 'Dose'},
    {key: 'frequency', label: 'Frequency'},
    {key: 'route', label: 'Route'},
    {key: 'food', label: 'With Food'},
    {key: 'duration', label: 'Duration'}
  ];

  const [investigationRows, setInvestigationRows] = useState([
    {investigation: 'CBC', female: '', male: ''},
    {investigation: 'Blood group', female: '', male: ''},
    {investigation: 'TSH', female: '', male: ''},
    {investigation: 'SFT3/FT4', female: '', male: ''},
    {investigation: 'Prolactin', female: '', male: ''},
    {investigation: 'AMH', female: '', male: ''},
    {investigation: 'HIV,HBsAg,Anti-HCV,VDRL', female: '', male: ''},
    {investigation: 'Urea/Creatinine', female: '', male: ''},
    {investigation: 'RBS,HbA1c', female: '', male: ''},
    {investigation: 'Semen test', female: '', male: ''},
    {investigation: 'Karyotype if necessary', female: '', male: ''},
    {investigation: 'DFI if necessary', female: '', male: ''}
  ]);

  const [planRows, setPlanRows] = useState([
    {male: '', female: ''},
    {male: '', female: ''}
  ]);

  const [medicationRows, setMedicationRows] = useState([
    {
      sno: '1',
      drug: 'Intafol D/FOLVISTA',
      genericName: 'Folic Acid + Vitamin D',
      dose: '1 tab',
      frequency: 'Daily',
      time: 'Morning',
      duration: '30 days'
    },
    {
      sno: '2',
      drug: 'Vit D3 60K',
      genericName: 'Cholecalciferol',
      dose: '60,000 IU',
      frequency: 'Weekly',
      time: 'Once with milk',
      duration: '8 weeks'
    }
  ]);

  const [maleMedicationRows, setMaleMedicationRows] = useState([
    {
      sno: '1',
      drug: 'Evion/ETAMIN 400 mg',
      genericName: 'Vitamin E',
      dose: '1 cap',
      frequency: 'Daily',
      time: 'Morning & Evening',
      duration: '30 days'
    },
    {
      sno: '2',
      drug: 'Vit D3 60K',
      genericName: 'Cholecalciferol',
      dose: '60,000 IU',
      frequency: 'Weekly',
      time: 'Once with milk',
      duration: '8 weeks'
    }
  ]);

  const normorespondersProtocol = [
    {
      sno: '1',
      drug: 'Tab. Folvista / Intafol-D / Vitagreat (Folic acid combination)',
      dose: '1 tab',
      frequency: 'Once daily at 9 AM',
      route: 'Oral',
      food: 'After food',
      duration: '30 days'
    },
    {
      sno: '2',
      drug: 'Tab. Etamin (Vitamin E combination)',
      dose: '400 mg',
      frequency: 'Once daily at 9 AM',
      route: 'Oral',
      food: 'After food',
      duration: '30 days'
    },
    {
      sno: '3',
      drug: 'QCo Complex (Coenzyme Q10 supplement)',
      dose: '1 tab',
      frequency: '1-0-1 (9 AM & 9 PM)',
      route: 'Oral',
      food: 'After food',
      duration: '30 days'
    },
    {
      sno: '4',
      drug: 'O3 Mega (Omega-3 supplement)',
      dose: '1 tab',
      frequency: 'Once daily at 9 PM',
      route: 'Oral',
      food: 'After food',
      duration: '30 days'
    },
    {
      sno: '5',
      drug: 'C Vit (Vitamin C)',
      dose: '1 tab',
      frequency: '1-0-1 (9 AM & 9 PM)',
      route: 'Oral',
      food: 'After food',
      duration: '30 days'
    },
    {
      sno: '6',
      drug: 'Tab. Progynova / Evatone (Estradiol valerate)',
      dose: '2 mg',
      frequency: '1-0-1 (9 AM & 9 PM)',
      route: 'Oral',
      food: 'After food',
      duration: 'From Day 16 until Day 1'
    },
    {
      sno: '7',
      drug: 'Tab. Nortas CR / Meparate (Medroxyprogesterone 10 mg)',
      dose: '10 mg',
      frequency: '1-0-1',
      route: 'Oral',
      food: 'After food',
      duration: 'Day 16 to Day 22'
    },
    {
      sno: '8',
      drug: 'Inj. Lupride (Leuprolide Acetate)',
      dose: '8 units',
      frequency: 'As prescribed',
      route: 'SC',
      food: '---',
      duration: 'As per protocol'
    }
  ];

  const poorRespondersProtocol = [
    {
      sno: '1',
      drug: 'Tab. Folvista / Intafol-D / Vitagreat (Folic acid combination)',
      dose: '1 tab',
      frequency: 'Once daily at 9 AM',
      route: 'Oral',
      food: 'After food',
      duration: '60 days'
    },
    {
      sno: '2',
      drug: 'Tab. Etamin (Vitamin E combination)',
      dose: '400 mg',
      frequency: 'Once daily at 9 AM',
      route: 'Oral',
      food: 'After food',
      duration: '60 days'
    },
    {
      sno: '3',
      drug: 'QCo Complex (Coenzyme Q10 supplement)',
      dose: '1 tab',
      frequency: '1-0-1 (9 AM & 9 PM)',
      route: 'Oral',
      food: 'After food',
      duration: '60 days'
    },
    {
      sno: '4',
      drug: 'Tab. KQ Fert (Antioxidant & fertility support)',
      dose: '1 tab',
      frequency: 'Once daily at 9 PM',
      route: 'Oral',
      food: 'After food',
      duration: '30 days'
    },
    {
      sno: '5',
      drug: 'Tab. Sure MA XT (Multivitamin-Mineral complex)',
      dose: '1 tab',
      frequency: 'Once daily at 9 PM',
      route: 'Oral',
      food: 'After food',
      duration: '30 days'
    },
    {
      sno: '6',
      drug: 'Tab. Ovaflo (DHEA + Myo-inositol + Vitamin D3)',
      dose: '1 tab',
      frequency: 'Once daily at 2 PM',
      route: 'Oral',
      food: 'After food',
      duration: '60 days'
    },
    {
      sno: '7',
      drug: 'Androtas / Androfirst Gel (Transdermal Testosterone Gel)',
      dose: '1 pump',
      frequency: 'Morning & Evening',
      route: 'Transdermal',
      food: '---',
      duration: '60 days'
    },
    {
      sno: '8',
      drug: 'O3 Mega (Omega-3 supplement)',
      dose: '1 tab',
      frequency: 'Once daily at 9 PM',
      route: 'Oral',
      food: 'After food',
      duration: '30 days'
    },
    {
      sno: '9',
      drug: 'C Vit (Vitamin C)',
      dose: '1 tab',
      frequency: '1-0-1 (9 AM & 9 PM)',
      route: 'Oral',
      food: 'After food',
      duration: '30 days'
    },
    {
      sno: '10',
      drug: 'Tab. Progynova / Evatone (Estradiol valerate)',
      dose: '2 mg',
      frequency: '1-0-1 (9 AM & 9 PM)',
      route: 'Oral',
      food: 'After food',
      duration: 'From Day 16 until Day 1'
    },
    {
      sno: '11',
      drug: 'Tab. Nortas CR / Meparate (Medroxyprogesterone 10 mg)',
      dose: '10 mg',
      frequency: '1-0-1',
      route: 'Oral',
      food: 'After food',
      duration: 'Day 16 to Day 22'
    },
    {
      sno: '12',
      drug: 'Inj. Lupride (Leuprolide Acetate)',
      dose: '8 units',
      frequency: 'As advised',
      route: 'SC (Subcut)',
      food: '---',
      duration: 'As per protocol'
    }
  ];

  const hyperrespondersProtocol = [
    {
      sno: '1',
      drug: 'Tab. Folvista / Intafol-D / Vitagreat (Folic acid combination)',
      dose: '1 tab',
      frequency: 'Once daily at 9 AM',
      route: 'Oral',
      food: 'After food',
      duration: '60 days'
    },
    {
      sno: '2',
      drug: 'Tab. Etamin (Vitamin E combination)',
      dose: '400 mg',
      frequency: 'Once daily at 9 AM',
      route: 'Oral',
      food: 'After food',
      duration: '60 days'
    },
    {
      sno: '3',
      drug: 'Tab. Myo D3 (Myo-inositol + D-chiro-inositol + Vitamin D3)',
      dose: '1 tab',
      frequency: 'Once daily at 9 PM',
      route: 'Oral',
      food: 'After food',
      duration: '60 days'
    },
    {
      sno: '4',
      drug: 'Tab. Glycomet (Metformin)',
      dose: '500 mg or as advised',
      frequency: '1-0-1',
      route: 'Oral',
      food: 'After food',
      duration: '60 days'
    },
    {
      sno: '5',
      drug: 'O3 Mega (Omega-3 supplement)',
      dose: '1 tab',
      frequency: 'Once daily at 9 PM',
      route: 'Oral',
      food: 'After food',
      duration: '30 days'
    },
    {
      sno: '6',
      drug: 'C Vit (Vitamin C)',
      dose: '1 tab',
      frequency: '1-0-1 (9 AM & 9 PM)',
      route: 'Oral',
      food: 'After food',
      duration: '30 days'
    },
    {
      sno: '7',
      drug: 'Tab. Nortas CR / Meparate (Medroxyprogesterone 10 mg)',
      dose: '10 mg',
      frequency: '1-0-1',
      route: 'Oral',
      food: 'After food',
      duration: 'Day 16 to Day 22'
    }
  ];

  const maleFactorProtocol = [
    {
      sno: '1',
      drug: 'Tab. Folvista / Intafol-D / Vitagreat (Folic acid combination)',
      dose: '1 tab',
      frequency: 'Once daily at 9 AM',
      route: 'Oral',
      food: 'After food',
      duration: '30 days'
    },
    {
      sno: '2',
      drug: 'Tab. Etamin (Vitamin E combination)',
      dose: '400 mg',
      frequency: 'Once daily at 9 AM',
      route: 'Oral',
      food: 'After food',
      duration: '30 days'
    },
    {
      sno: '3',
      drug: 'UltraQ 300 / Ferpill Max / Infuse M (Coenzyme Q10 supplement)',
      dose: '1 tab',
      frequency: '1-0-1 (9 AM & 9 PM)',
      route: 'Oral',
      food: 'After food',
      duration: '30 days'
    },
    {
      sno: '4',
      drug: 'O3 Mega (Omega-3 supplement)',
      dose: '1 tab',
      frequency: 'Once daily at 9 PM',
      route: 'Oral',
      food: 'After food',
      duration: '30 days'
    },
    {
      sno: '5',
      drug: 'C Vit (Vitamin C)',
      dose: '1 tab',
      frequency: '1-0-1 (9 AM & 9 PM)',
      route: 'Oral',
      food: 'After food',
      duration: '30 days'
    }
  ];
  const [femalePreTreatmentRows, setFemalePreTreatmentRows] = useState([]);
  const [malePreTreatmentRows, setMalePreTreatmentRows] = useState([]);

  useEffect(() => {
    switch (femaleProtocolType) {
      case 'poor Responders':
        setFemalePreTreatmentRows([...poorRespondersProtocol]);
        break;
      case 'Hyperresponders':
        setFemalePreTreatmentRows([...hyperrespondersProtocol]);
        break;
      default:
        setFemalePreTreatmentRows([...normorespondersProtocol]);
    }
  }, [femaleProtocolType]);

  useEffect(() => {
    switch (maleProtocolType) {
      case 'Male Factor':
        setMalePreTreatmentRows([...maleFactorProtocol]);
        break;
      default:
        setMalePreTreatmentRows([...maleFactorProtocol]);
    }
  }, [maleProtocolType]);

  const labelStyles = {
    fontWeight: '600',
    marginRight: '5px',
    width: 'max-content'
  };

  useEffect(() => {
    const fetchData = async () => {
      const payload = {
        p_uhid: props.patientsData.p_uhid
      };
      props.loaderchange('true');
      const addPatient = fetchPatientDetailsUuid(payload);
      const response = await dispatch(addPatient);
      if (response.payload?.status?.code === 200) {
        const data1 = response.payload.data.data[0].gender == 'Male' ? response.payload.data.data[0] : response.payload.data.data[1];
        const data2 = response.payload.data.data[0].gender == 'Female' ? response.payload.data.data[0] : response.payload.data.data[1];
        const namePat1 = data1?.titles + ' ' + data1?.first_name + ' ' + data1?.last_name;
        const namePat2 = data2?.titles + ' ' + data2?.first_name + ' ' + data2?.last_name;

        setPatientOne_UUId(data1?.id);
        setFormData({
          ...formData,
          patientName1: namePat1,
          age1: data1?.age,
          gender1: data1?.gender,
          patientId1: data1?.p_uhid,

          patientName2: namePat2,
          age2: data2?.age,
          gender2: data2?.gender,
          patientId2: data2?.p_uhid
        });
        // }
        props.loaderchange('false');
      }
      return;
    };

    fetchData();
  }, []);

  const handleChange = e => {
    var text = e.target.value;

    if (e.target.name === 'patientId1' || e.target.name === 'patientId2') {
      if (e.target.value.length === 10 && e.target.value.charAt(0) === 'A') {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value
          };
          props.loaderchange('true');
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data1 = response.payload.data.data[0].gender == 'Male' ? response.payload.data.data[0] : response.payload.data.data[1];
            const data2 = response.payload.data.data[0].gender == 'Female' ? response.payload.data.data[0] : response.payload.data.data[1];
            const namePat1 = data1?.titles + ' ' + data1?.first_name + ' ' + data1?.last_name;
            const namePat2 = data2?.titles + ' ' + data2?.first_name + ' ' + data2?.last_name;
            if (e.target.name === 'patientId1' || e.target.name === 'patientId2') {
              setPatientOne_UUId(data1?.id);
              setFormData({
                ...formData,

                patientName1: namePat1,
                age1: data1?.age,
                gender1: data1?.gender,
                patientId1: data1?.p_uhid,

                patientName2: namePat2,
                age2: data2?.age,
                gender2: data2?.gender,
                patientId2: data2?.p_uhid
              });
            }
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }

          return;
        };

        fetchData();
      } else {
        if (e.target.name === 'patientId1') {
          setFormData({
            ...formData,
            patientId1: e.target.value
          });
        }
        if (e.target.name === 'patientId2') {
          setFormData({
            ...formData,
            patientId2: e.target.value
          });
        }
      }
    } else {
      const name = e.target.name;
      const value = e.target.value;
      const id = name?.split('_')[1];

      setFormData({...formData, [e.target.name]: e.target.value});
      if (e.target.name === 'nextappointment') {
        const dateTime = e.target.value.split('T');
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData.p_uhid,
          name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
          status: 'Not Visited',
          notes: 'Booking Visit',
          patient_id: patientId
        });
      }
    }
  };

  const renderReportfield = (name, value, options = {}) => {
    const {styleSec = {}, styleLabel = {}, styleSpan = {}} = options;

    return (
      <>
        <section style={{...styleSec, margin: '0 10px 10px 10px', display: 'flex'}}>
          <label
            style={{
              ...styleLabel,
              fontWeight: '600',
              marginRight: '5px',
              width: 'max-content'
            }}>
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };

  const renderTableTD = (value, isHeader = false) => {
    return (
      <td
        style={{
          border: '1px solid black',
          textAlign: 'center',
          fontWeight: isHeader ? 'bold' : 'normal',
          padding: '8px'
        }}>
        {value}
      </td>
    );
  };

  const renderTableTH = value => {
    return (
      <th
        style={{
          border: '1px solid black',
          textAlign: 'center',
          fontWeight: 'bold',
          padding: '8px'
        }}>
        {value}
      </th>
    );
  };

  const handlesubmit = () => {
    try {
      if (patientOne_UUId !== '' && formData.patientId1 !== '' && formData.patientId1.length === 10) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById('planningSummaryReportWrap').innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'Planning Summary'
            }
          };

          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  const handleNill = id => {
    setShowTables(prev => ({...prev, [id]: false}));
  };

  return (
    <div id='PlanningSummary'>
      <div className='PlanningSummary'>
        <div className='' style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img
              className='header_image'
              src={headerimage}
              style={{
                width: '100%',
                margin: '0 auto'
              }}></img>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'center',
              gap: '3px',
              backgroundColor: '#f7f7f7 ',
              borderRadius: '6px',
              padding: '16px 8px 16px 8px',
              gap: '3px'
            }}>
            <div className='row pb-3'>
              <div className='col-md-6' style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                <FormInputWithLabel label='Patient ID' name='patientId1' value={formData.patientId1} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
                <FormInputWithLabel label='Patient Name' name='patientName1' value={formData.patientName1} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '145px 16px 300px',
                    alignItems: 'center '
                  }}>
                  <span style={{fontWeight: 600}}>Gender</span>
                  <span style={{fontWeight: 600}}>:</span>
                  <select
                    className={`createTime ${show ? 'hide' : 'show'}`}
                    onChange={e => handleChange(e)}
                    value={formData.gender1}
                    name='gender1'
                    style={{
                      border: '1px solid #ddd',
                      outline: 'none',
                      padding: '10px',
                      backgroundColor: 'white'
                    }}>
                    <option value='' disabled selected>
                      Select Gender
                    </option>
                    <option value='Male'>Male</option>
                    <option value='Female'>Female</option>
                    <option value='Others'>Others</option>
                    <option value='Decline to State'>Decline to State</option>
                  </select>
                  <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.gender1}</span>
                </div>
                <FormInputWithLabel label='Age' name='age1' value={formData.age1} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
              </div>
              <div className='col-md-6' style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                <FormInputWithLabel label='Patient ID' name='patientId2' value={formData.patientId2} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
                <FormInputWithLabel label='Patient Name' name='patientName2' value={formData.patientName2} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '145px 16px 300px',
                    alignItems: 'center '
                  }}>
                  <span style={{fontWeight: 600}}>Gender</span>
                  <span style={{fontWeight: 600}}>:</span>
                  <select
                    className={`createTime ${show ? 'hide' : 'show'}`}
                    onChange={e => handleChange(e)}
                    value={formData.gender2}
                    name='gender2'
                    style={{
                      border: '1px solid #ddd',
                      outline: 'none',
                      padding: '10px',
                      backgroundColor: 'white'
                    }}>
                    <option value='' disabled selected>
                      Select Gender
                    </option>
                    <option value='Male'>Male</option>
                    <option value='Female'>Female</option>
                    <option value='Others'>Others</option>
                    <option value='Decline to State'>Decline to State</option>
                  </select>
                  <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.gender2}</span>
                </div>
                <FormInputWithLabel label='Age' name='age2' value={formData.age2} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
              </div>
            </div>
          </div>
        </div>
        <div className='row mt-2' style={{textAlign: 'center'}}>
          <h3>PLANNING SUMMARY</h3>
        </div>

        <div className='row mt-2'>
          <div className='col-md-6'>
            <ReportFormInputWithLabel label='Comordidities (Male):' name='comorbiditiesMale' value={formData.comorbiditiesMale} onChange={handleChange} show={true} />
          </div>
          <div className='col-md-6'>
            <ReportFormInputWithLabel label='Comordidities (Female):' name='comorbiditiesFemale' value={formData.comorbiditiesFemale} onChange={handleChange} show={true} />
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <ReportFormInputWithLabel label='HSG :' name='hsg' value={formData.hsg} onChange={handleChange} show={true} />
          </div>
          <div className='col-md-6'>
            <ReportFormInputWithLabel label='SSG :' name='ssg' value={formData.ssg} onChange={handleChange} show={true} />
          </div>
        </div>
        <div className='row mt-2'>
        <div className='col-md-6'>
            <ReportFormInputWithLabel label='Laparoscopy:' name='laparoscopy' value={formData.laparoscopy} onChange={handleChange} show={true} />
          </div>
          <div className='col-md-6'>
            <ReportFormInputWithLabel label='USG abdomen :' name='usg' value={formData.usg} onChange={handleChange} show={true} />
        </div>
        </div>

        <div className='detail'>
          {showTables.investigation && (
            <TemplateTable
              id='investigation'
              title='RECOMMENDED BASIC INVESTIGATIONS'
              headers={investigationHeaders}
              rows={investigationRows}
              onRowsChange={(id, newRows) => setInvestigationRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('investigation')}
            />
          )}

          {showTables.plan && (
            <TemplateTable id='plan' title='Plan :' headers={planHeaders} rows={planRows} onRowsChange={(id, newRows) => setPlanRows(newRows)} enableActions={true} onNill={() => handleNill('plan')} />
          )}

          {showTables['female-medication'] && (
            <TemplateTable
              id='female-medication'
              title='Female Medications:'
              headers={medicationHeaders}
              rows={medicationRows}
              onRowsChange={(id, newRows) => setMedicationRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('female-medication')}
            />
          )}

          {showTables['male-medication'] && (
            <TemplateTable
              id='male-medication'
              title='Male Medications:'
              headers={medicationHeaders}
              rows={maleMedicationRows}
              onRowsChange={(id, newRows) => setMaleMedicationRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('male-medication')}
            />
          )}

          <div className='row'>
            <h4>Protocol Type:</h4>
            <div className='row my-3'>
              <div className='col-12 d-flex justify-content-start align-items-center'>
                <span style={{fontWeight: 600}}>Female:</span>
                <select
                  className={`createTime ${show ? 'hide' : 'show'}`}
                  value={femaleProtocolType}
                  onChange={e => setFemaleProtocolType(e.target.value)}
                  style={{
                    border: '1px solid #ddd',
                    outline: 'none',
                    padding: '10px',
                    backgroundColor: 'white',
                    minWidth: '200px'
                  }}>
                  <option value='Normoresponders'>Normoresponders</option>
                  <option value='poor Responders'>Poor Responders</option>
                  <option value='Hyperresponders'>Hyperresponders</option>
                </select>
              </div>
            </div>
          </div>
          {showTables['female-pretreatment-protocol'] && (
            <TemplateTable
              id='female-pretreatment-protocol'
              title={`📝 Pretreatment Protocol -- ${femaleProtocolType} (ASCAS)`}
              headers={preTreatmentHeaders}
              rows={femalePreTreatmentRows}
              onRowsChange={(id, newRows) => setFemalePreTreatmentRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('female-pretreatment-protocol')}
            />
          )}

          <div className='row'>
            <div className='col-12 d-flex justify-content-start align-items-center'>
              <span style={{fontWeight: 600}}>Male:</span>
              <select
                className={`createTime ${show ? 'hide' : 'show'}`}
                value={maleProtocolType}
                onChange={e => setMaleProtocolType(e.target.value)}
                style={{
                  border: '1px solid #ddd',
                  outline: 'none',
                  padding: '10px',
                  backgroundColor: 'white',
                  minWidth: '200px'
                }}>
                <option value='Male Factor'>Male Factor</option>
              </select>
            </div>
          </div>

          {showTables['male-pretreatment-protocol'] && (
            <TemplateTable
              id='male-pretreatment-protocol'
              title={`📝 Pretreatment Protocol -- ${maleProtocolType} (ASCAS)`}
              headers={preTreatmentHeaders}
              rows={malePreTreatmentRows}
              onRowsChange={(id, newRows) => setMalePreTreatmentRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('male-pretreatment-protocol')}
            />
          )}

          <div className='bulletin pt-3'>
            <p>
              <strong>NOTE:</strong> Please follow the diet as prescribed in your personalized diet chart, and watch Dr. Aishwarya’s videos on the Doctor Mommies YouTube Channel for further guidance
              and lifestyle tips.
            </p>
          </div>

          <p className='pt-3' style={{fontWeight: '600'}}>
            NEXT APPOINTMENT - <input name='nextappointment' onChange={handleChange} type='datetime-local' className={`createTime ${show ? 'hide' : 'show'}`} />
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{appointmentData.date?.split('-').reverse().join('-')}</span>
          </p>

          <div className={`Footer ${show ? 'hide' : 'show'}`}>
            <button onClick={handlesubmit} className='Button_Create'>
              Add Report
            </button>
          </div>
        </div>
      </div>

      {/* Report Generation Section */}
      <div id='planningSummaryReport'>
        <div id='planningSummaryReportWrap'>
          <Headers />
          <p class='Dani'></p>
          <div
            className='firstPartner'
            style={{
              border: '1px solid black',
              borderRadius: '10px',
              marginBottom: '10px'
            }}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '10px'}}>
              {renderReportfield('Patient Name :', formData.patientName1, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Patient ID :', formData.patientId1, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Gender :', formData.gender1, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Age :', formData.age1, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
            </div>
          </div>
          <div className='secondPartner' style={{border: '1px solid black', borderRadius: '10px'}}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '10px'}}>
              {renderReportfield('Patient Name :', formData.patientName2, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Patient ID :', formData.patientId2, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Gender :', formData.gender2, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Age :', formData.age2, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
            </div>
          </div>

          <div style={{marginTop: '20px', display: 'flex', justifyContent: 'center'}}>
            <h4 style={{fontWeight: 600, color: '#333', marginBottom: '15px'}}>PLANNING SUMMARY</h4>
          </div>

          <div style={{display: 'flex', flexWrap: 'wrap', marginTop: '10px'}}>
            {renderReportfield('Comordidities (Male) :', formData.comorbiditiesMale, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex', width: '45%'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Comordidities (Female) :', formData.comorbiditiesFemale, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex', width: '45%'},
              styleLabel: labelStyles
            })}
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginTop: '10px'}}>
            {renderReportfield('HSG :', formData.hsg, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('SSG :', formData.ssg, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginTop: '10px'}}>
          {renderReportfield('Laparoscopy :', formData.laparoscopy, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('USG abdomen :', formData.usg, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
          })}
          </div>
          
          {showTables.investigation && (
            <>
              <div style={{display: 'flex', marginTop: '10px'}}>
                <h4 style={{fontWeight: 600, marginRight: '5px'}}>Recommended Base Investigations:</h4>
              </div>
              <table
                style={{
                  marginBottom: '10px',
                  border: '1px solid black',
                  width: '100%',
                  textAlign: 'center',
                  borderCollapse: 'collapse'
                }}>
                <thead>
                  <tr>{investigationHeaders.map((ele, ind) => renderTableTH(ele.label))}</tr>
                </thead>
                <tbody>
                  {investigationRows.map((row, i) => (
                    <tr key={i}>
                      {renderTableTD(row.investigation)}
                      {renderTableTD(row.female)}
                      {renderTableTD(row.male)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
          {showTables.plan && (
            <>
              <div style={{display: 'flex', marginTop: '10px'}}>
                <h4 style={{fontWeight: 600, marginRight: '5px'}}>Plan:</h4>
              </div>
              <table
                style={{
                  marginBottom: '10px',
                  border: '1px solid black',
                  width: '100%',
                  textAlign: 'center'
                }}>
                <thead>
                  <tr>{planHeaders.map((ele, ind) => renderTableTH(ele.label))}</tr>
                </thead>
                <tbody>
                  {planRows.map((row, i) => (
                    <tr key={i}>
                      {renderTableTD(row.female)}
                      {renderTableTD(row.male)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
          {showTables['female-medication'] && (
            <>
              <div style={{display: 'flex', marginTop: '10px'}}>
                <h4 style={{fontWeight: 600, marginRight: '5px'}}>Female Medications:</h4>
              </div>
              <table
                style={{
                  marginBottom: '10px',
                  border: '1px solid black',
                  width: '100%',
                  textAlign: 'center'
                }}>
                <thead>
                  <tr>{medicationHeaders.map((ele, ind) => renderTableTH(ele.label))}</tr>
                </thead>
                <tbody>
                  {medicationRows.map((row, i) => (
                    <tr key={i}>
                      {renderTableTD(row.sno)}
                      {renderTableTD(row.drug)}
                      {renderTableTD(row.genericName)}
                      {renderTableTD(row.dose)}
                      {renderTableTD(row.frequency)}
                      {renderTableTD(row.time)}
                      {renderTableTD(row.duration)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
          {showTables['male-medication'] && (
            <>
              <div style={{display: 'flex', marginTop: '10px'}}>
                <h4 style={{fontWeight: 600, marginRight: '5px'}}>Male Medications:</h4>
              </div>
              <table
                style={{
                  marginBottom: '10px',
                  border: '1px solid black',
                  width: '100%',
                  textAlign: 'center'
                }}>
                <thead>
                  <tr>{medicationHeaders.map((ele, ind) => renderTableTH(ele.label))}</tr>
                </thead>
                <tbody>
                  {maleMedicationRows.map((row, i) => (
                    <tr key={i}>
                      {renderTableTD(row.sno)}
                      {renderTableTD(row.drug)}
                      {renderTableTD(row.genericName)}
                      {renderTableTD(row.dose)}
                      {renderTableTD(row.frequency)}
                      {renderTableTD(row.time)}
                      {renderTableTD(row.duration)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
          {showTables['female-pretreatment-protocol'] && (
            <>
              <div style={{display: 'flex', marginTop: '10px'}}>
                <h4 style={{fontWeight: 600, marginRight: '5px'}}>📝 Pretreatment Protocol -- {femaleProtocolType} (ASCAS)</h4>
              </div>
              <table
                style={{
                  marginBottom: '10px',
                  border: '1px solid black',
                  width: '100%',
                  textAlign: 'center'
                }}>
                <thead>
                  <tr>
                    <th>S. No</th>
                    <th>Drug (Brand Name) / Generic Category</th>
                    <th>Dose</th>
                    <th>Frequency</th>
                    <th>Route</th>
                    <th>With Food</th>
                    <th>Duration</th>
                  </tr>
                </thead>
                <tbody>
                  {femalePreTreatmentRows.map((row, index) => (
                    <tr key={index}>
                      {renderTableTD(row.sno)}
                      {renderTableTD(row.drug)}
                      {renderTableTD(row.dose)}
                      {renderTableTD(row.frequency)}
                      {renderTableTD(row.route)}
                      {renderTableTD(row.food)}
                      {renderTableTD(row.duration)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}

          {showTables['male-pretreatment-protocol'] && (
            <>
              <div style={{display: 'flex', marginTop: '10px'}}>
                <h4 style={{fontWeight: 600, marginRight: '5px'}}>📝 Pretreatment Protocol -- {maleProtocolType} (ASCAS)</h4>
              </div>
              <table
                style={{
                  marginBottom: '10px',
                  border: '1px solid black',
                  width: '100%',
                  textAlign: 'center'
                }}>
                <thead>
                  <tr>
                    <th>S. No</th>
                    <th>Drug (Brand Name) / Generic Category</th>
                    <th>Dose</th>
                    <th>Frequency</th>
                    <th>Route</th>
                    <th>With Food</th>
                    <th>Duration</th>
                  </tr>
                </thead>
                <tbody>
                  {malePreTreatmentRows.map((row, index) => (
                    <tr key={index}>
                      {renderTableTD(row.sno)}
                      {renderTableTD(row.drug)}
                      {renderTableTD(row.dose)}
                      {renderTableTD(row.frequency)}
                      {renderTableTD(row.route)}
                      {renderTableTD(row.food)}
                      {renderTableTD(row.duration)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}

          <div className='bulletin pt-3'>
            <p>
              <strong>NOTE:</strong> Please follow the diet as prescribed in your personalized diet chart, and watch Dr. Aishwarya’s videos on the Doctor Mommies YouTube Channel for further guidance
              and lifestyle tips.
            </p>
          </div>

          <div style={{display: 'flex', marginBottom: '10px'}}>{renderReportfield('Next Appointment :', appointmentData.date?.split('-').reverse().join('-'))}</div>
          <p class='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}